import { NgModule, inject, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { PageEditorComponent } from './page-editor/page-editor.component';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { FrontPageComponent } from './front-page/front-page.component';
import { ManageUsersComponent } from 'src/app/page/admin/manage-users/manage-users.component';
import { GenericComponent } from 'src/app/page/generic/generic.component';
import { AuthGuard } from '@core/guards/auth.guard';
import { MenuEditorComponent } from './menu-editor/menu-editor.component';
import { ProfileComponent } from './profile/profile.component';
import { SubscribersComponent } from 'src/app/page/admin/subscribers/subscribers.component';

const routes: Routes = [
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        component: FrontPageComponent,
      },
      {
        path: 'menu-editor',
        component: MenuEditorComponent,
      },
      {
        path: 'page/:id',
        component: PageEditorComponent,
      },
      {
        path: 'users',
        component: ManageUsersComponent,
      },
      {
        path: 'subscribers',
        component: SubscribersComponent,
      },
      {
        path: 'draft-preview',
        component: GenericComponent, // need to pass data to this component
      },
      {
        path: 'profile',
        component: ProfileComponent,
      },

    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
